import { engineRequest } from './http';

// `status` is `active`, `archived` or `all`; `search` matches name and key.
export const listCategories = params =>
  engineRequest({ path: '/categories', params });

export const createCategory = fields =>
  engineRequest({ method: 'post', path: '/categories', data: fields });

// `key` is immutable.
export const updateCategory = (key, fields) =>
  engineRequest({ method: 'put', path: `/categories/${key}`, data: fields });

// Also deletes the category's routing rules. 409 `in_use` when tickets use it.
export const deleteCategory = key =>
  engineRequest({ method: 'delete', path: `/categories/${key}` });
